import { render, staticRenderFns } from "./AddressLink.vue?vue&type=template&id=19764646&scoped=true&"
import script from "./AddressLink.vue?vue&type=script&lang=ts&"
export * from "./AddressLink.vue?vue&type=script&lang=ts&"
import style0 from "./AddressLink.vue?vue&type=style&index=0&id=19764646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19764646",
  null
  
)

export default component.exports